import { SideBarTreeSection } from '../components/SideBar'
import { REPORT_URLS } from '../pages/reports/utils/urls'

export const Path = {
  ANALYST_NOTES: '/analyst-notes',
  ANNOTATION: '/annotation',
  ARTIFICIAL_ETFS: '/reports/artificialetfs',
  ARTIFICIAL_ETFS_NEW: '/reports/artificial_etfs',
  ARTIFICIAL_ETFS_ANALYSIS: '/reports/artificialetfs/analysis',
  ARTIFICIAL_ETFS_LAUNCHPAD: '/reports/artificialetfs/launchpad',
  BASKETS: '/baskets',
  CLASSIFICATION_ANALYSIS: REPORT_URLS['classification-analysis'],
  CLASSIFICATION_MANAGER: '/reports/classification_manager',
  COOLTABLE: '/cooltable',
  CURVA_EMPRESAS_V2: '/curva-empresas-v2',
  DADOS_DE_MERCADO: '/dados-de-mercado',
  PIPELINE_ANALISE_CREDITO: '/research',
  HDS: '/hds',
  CALLS_TRADES: '/calls-e-trades',
  CONTROLE_HEDGE: '/controle-hedge',
  CVM: '/reports/cvm',
  CVM_ANALYSIS: REPORT_URLS['cvm'],
  CVM_LONG_BIAS_LAUNCHPAD: '/reports/cvm/long_bias_launchpad',
  CVM_LONG_ONLY_LAUNCHPAD: '/reports/cvm/long_only_launchpad',
  DEPUTIES_VOTES: '/reports/deputies_votes',
  ESG: '/esg',
  ESG_EDIT_FRAMEWORK: '/esg/edit-framework',
  ESG_EDIT_RESPONSE: '/esg/edit-response',
  ESG_FRAMEWORK_MANAGER: '/esg/framework-manager',
  ESG_REPORTS: '/esg/reports',
  HOME: '/',
  INSIDER_TRADING: REPORT_URLS['insider-trading'],
  INTRADAY_MONITOR: '/intraday-monitor',
  LAUNCHPAD: '/launchpad',
  LAUNCHPAD_REAL_ESTATE: '/launchpad/real_estate',
  LOGIN: '/login',
  REPORTS_MACRO_ANALYSIS: REPORT_URLS['macro-analysis'],
  MACRO_REPORT: REPORT_URLS['macro-report'],
  MARKET_STRUCTURE: REPORT_URLS['market-structure'],
  MERGE_AND_ACQUISITIONS: '/reports/merge_and_acquisitions',
  MERGE_AND_ACQUISITIONS_ANALYSIS: '/reports/merge_and_acquisitions/analysis',
  MERGE_AND_ACQUISITIONS_FILES: '/reports/merge_and_acquisitions/files',
  MOMENTUM_SCREENING: '/momentum-screening',
  NOTIFICATIONS_MANAGER: '/reports/notifications',
  PEERS: REPORT_URLS['peers'],
  // Peers de fundos do Crédito Líquido — distinto de PEERS, que é o relatório
  // de comparáveis de equities sob /reports.
  PEERS_MERCADO: '/peers-mercado',
  PERFORMANCE_ATTRIBUTION: '/reports/performance_attribution',
  PORTFOLIO_ANALYSIS: REPORT_URLS['portfolio-analysis'],
  PORTFOLIO: '/portfolio',
  PORTFOLIO_OPTIONS: '/portfolio/options',
  PORTFOLIO_PERFORMANCE_FEE: '/portfolio/performance-fee',
  PORTFOLIO_REAL_ESTATE: '/portfolio/real_estate',
  PORTFOLIO_REAL_ESTATE_OPTIONS: '/portfolio/real_estate/options',
  PRESENTATIONS: '/presentations',
  PRESENTATIONS_BANKS: '/presentations/banks',
  PRESENTATIONS_BANKS_DEFAULT: '/presentations/banks_default',
  PRESENTATIONS_COMMODITIES_COVERAGE: '/presentations/commodities_coverage',
  PRESENTATIONS_DIVIDENDS: '/presentations/dividends',
  PRESENTATIONS_HAPVIDA: '/presentations/hapvida',
  PRESENTATIONS_LTEIXEIRA_COVERAGE: '/presentations/lteixeira_coverage',
  PRESENTATIONS_METALS_AND_MINING: '/presentations/metals_and_mining',
  PRESENTATIONS_MULTIFACTOR_MODELS: '/presentations/multifactor_models',
  PRESENTATIONS_NORMS: '/presentations/norms',
  PRESENTATIONS_PORTFOLIO_INSIGHTS: '/presentations/portfolio_insights',
  PRESENTATIONS_PERFORMANCE_ATTRIBUTION:
    '/presentations/performance_attribution',
  PRESENTATIONS_PROMEIRO_COVERAGE: '/presentations/promeiro_coverage',
  PRESENTATIONS_SALES: '/presentations/sales',
  PRESENTATIONS_SPX_PAPERS: '/presentations/spx_papers',
  PRESENTATIONS_STRATEGY: '/presentations/strategy',
  PRESENTATIONS_STRATEGY_SPX: '/presentations/strategy_spx',
  PRESENTATIONS_TELECOM: '/presentations/telecom',
  PRESENTATIONS_TRADING_IDEAS: '/presentations/trading_ideas',
  PRESENTATIONS_TRADING_TRADING_REPORT: '/presentations/trading_report',
  PRESENTATIONS_TRADING_BUYBACK: '/presentations/trading_buyback',
  PRESENTATIONS_UTILITIES: '/presentations/utilities',
  PRESENTATIONS_MGREENMAN_AND_DPONDE_COVERAGE:
    '/presentations/mgreenman_and_dponde_coverage',
  PRESENTATIONS_ULOREA_COVERAGE: '/presentations/ulorea_coverage',
  PRESENTATIONS_VALUATION_SPX: '/presentations/valuation_spx',
  REGISTER: '/register',
  REGISTER_COMPLETE: '/register/complete',
  REGISTER_CREATEACCOUNT: '/register/createaccount',
  REPORTS: '/reports',
  REPORTS_AGRO: '/reports/agro',
  REPORTS_AGRO_ANALYSIS: REPORT_URLS['agro'],
  REPORTS_AGRO_FILES: '/reports/agro/files',
  REPORTS_AI_FILES: REPORT_URLS['ai-files'],
  REPORTS_AIRLINES: '/reports/airlines',
  REPORTS_APPAREL: REPORT_URLS['apparel'],
  REPORTS_BANKS: '/reports/banks',
  REPORTS_BANKS_ANALYSIS: REPORT_URLS['banks'],
  REPORTS_BANKS_FILES: '/reports/banks/files',
  REPORTS_CREDIT: REPORT_URLS['credit'],
  REPORTS_CREDIT_LIQUID_PORTFOLIO: REPORT_URLS['credit-liquid-portfolio'],
  REPORTS_OVERVIEW: REPORT_URLS['overview'],
  REPORTS_PROTEINS: '/reports/proteins',
  REPORTS_PROTEINS_ANALYSIS: REPORT_URLS['proteins'],
  REPORTS_PROTEINS_AUS_BEEF: REPORT_URLS['proteins-aus-beef'],
  REPORTS_PROTEINS_BZ_BEEF: REPORT_URLS['proteins-bz-beef'],
  REPORTS_PROTEINS_BZ_CHICKEN: REPORT_URLS['proteins-bz-chicken'],
  REPORTS_PROTEINS_GLOBAL_MARKETS: REPORT_URLS['proteins-global-markets'],
  REPORTS_PROTEINS_US_BEEF: REPORT_URLS['proteins-us-beef'],
  REPORTS_PROTEINS_US_CHICKEN: REPORT_URLS['proteins-us-chicken'],
  REPORTS_PROTEINS_US_PORK: REPORT_URLS['proteins-us-pork'],
  REPORTS_PROTEINS_VALUATION: REPORT_URLS['proteins-valuation'],
  REPORTS_PROTEINS_FILES: '/reports/proteins/files',
  REPORTS_CAPITAL_MARKETS: REPORT_URLS['capital-markets'],
  REPORTS_CAR_RENTAL: REPORT_URLS['car-rental'],
  REPORTS_CHINA_BATTERY_MATERIALS: REPORT_URLS['china-battery-materials'],
  REPORTS_COMMODITIES: REPORT_URLS['commodities'],
  REPORTS_COMPASS_LLM: REPORT_URLS['compass-llm'],
  REPORTS_CONSUMER: REPORT_URLS['consumer'],
  REPORTS_CONSUMER_MONITOR: REPORT_URLS['consumer-monitor'],
  REPORTS_CONSOLIDATED_FIDCS: REPORT_URLS['consolidated-fidcs'],
  REPORTS_CREDIT_COMMODITIES: REPORT_URLS['credit-commodities'],
  REPORTS_CRYPTO: REPORT_URLS['crypto'],
  REPORTS_CRYPTO_LAUNCHPAD: '/reports/crypto/launchpad',
  REPORTS_DASHBOARD: '/reports/dashboard_tmp',
  REPORTS_DASHBOARD_TMP: REPORT_URLS['dashboard'],
  REPORTS_CGE_SPECIALIST: '/reports/cgespecialist',
  REPORTS_DISPERSION_PLOT: '/reports/dispersionplot',
  REPORTS_DISTRIBUTION: REPORT_URLS['distribution'],
  REPORTS_EARNINGS_SURPRISE: REPORT_URLS['earnings-surprise'],
  REPORTS_EDUCATION: '/reports/education',
  REPORTS_EDUCATION_SUPERIOR: '/reports/education/superior',
  REPORTS_EDUCATION_VALUATION: REPORT_URLS['education-valuation'],
  REPORTS_ENERGY_SHORTAGE: REPORT_URLS['energy-shortage-overview'],
  REPORTS_EQUITY_HEDGE: REPORT_URLS['equity-hedge'],
  REPORTS_EXCHANGE: REPORT_URLS['exchange'],
  REPORTS_E_COMMERCE: '/reports/ecommerce',
  REPORTS_E_COMMERCE_AMAZON: REPORT_URLS['ecommerce-amazon'],
  REPORTS_E_COMMERCE_ENJOEI: REPORT_URLS['ecommerce-enjoei'],
  REPORTS_E_COMMERCE_LAUNCHPAD: '/reports/ecommerce/launchpad',
  REPORTS_E_COMMERCE_MELI: REPORT_URLS['ecommerce-meli'],
  REPORTS_E_COMMERCE_ROTHYS: REPORT_URLS['ecommerce-rothys'],
  REPORTS_E_COMMERCE_SELLERS_MELI: REPORT_URLS['ecommerce-sellers-meli'],
  REPORTS_E_COMMERCE_VALUATION: REPORT_URLS['ecommerce-valuation'],
  REPORTS_E_COMMERCE_WESTWING: REPORT_URLS['ecommerce-westwing'],
  REPORTS_FINANCIAL_FRAUD: REPORT_URLS['financial-fraud'],
  REPORTS_FINANCIAL_STATEMENT: '/reports/financial_statement',
  REPORTS_FINANCIAL_STATEMENT_IBOV: REPORT_URLS['financial-statement-ibov'],
  REPORTS_FINANCIAL_STATEMENT_NON_FINANCIAL:
    REPORT_URLS['financial-statement-non-financial'],
  REPORTS_FINANCIAL_STATEMENT_FINANCIALS:
    REPORT_URLS['financial-statement-financials'],
  REPORTS_FLOW: REPORT_URLS['flow'],
  REPORTS_GLOBAL_SCENARIO: REPORT_URLS['global-scenario'],
  REPORTS_HEALTHCARE: '/reports/healthcare',
  REPORTS_HEALTHCARE_MEMBROS: '/reports/healthcare/membros',
  REPORTS_HEALTHCARE_OPERADORAS: '/reports/healthcare/operadoras',
  REPORTS_HEALTHCARE_OPERATORS_BY_REGION:
    '/reports/healthcare/operators_by_region',
  REPORTS_HEALTHCARE_UPDATE_MENSAL: '/reports/healthcare/update_mensal',
  REPORTS_HEALTHCARE_VALUATION: REPORT_URLS['healthcare-valuation'],
  REPORTS_HOMEBUILDERS: REPORT_URLS['homebuilders'],
  REPORTS_HTML_DASHBOARDS: REPORT_URLS['html-dashboards'],
  REPORTS_SWAP_MANAGER: REPORT_URLS['swap-manager'],
  REPORTS_INDUSTRIALS: REPORT_URLS['industrials'],
  REPORTS_INSURANCE: REPORT_URLS['insurance'],
  REPORTS_LAUNCHPAD_MONITOR: '/reports/launchpad_monitor',
  REPORTS_LIGHT: REPORT_URLS['light'],
  REPORTS_LITHIUM: REPORT_URLS['lithium'],
  REPORTS_METALS_AND_MINING: '/reports/metalsandmining',
  REPORTS_METALS_AND_MINING_ANALYSIS: REPORT_URLS['metals-and-mining'],
  REPORTS_METALS_AND_MINING_FILES: '/reports/metalsandmining/files',
  REPORTS_METALS_AND_MINING_LAUNCHPAD: '/reports/metalsandmining/launchpad',
  REPORTS_NLP_MODELS: REPORT_URLS['nlp-models'],
  REPORTS_OIL: '/reports/oil',
  REPORTS_OIL_ANALYSIS: REPORT_URLS['oil'],
  REPORTS_OIL_FILES: '/reports/oil/files',
  REPORTS_PAYMENTS: REPORT_URLS['payments'],
  REPORTS_POSITIONS: REPORT_URLS['positions'],
  REPORTS_UTILITIES: REPORT_URLS['utilities'],
  REPORTS_PULP_AND_PAPER: '/reports/pulp_and_paper',
  REPORTS_PULP_AND_PAPER_ANALYSIS: REPORT_URLS['pulp-and-paper'],
  REPORTS_PULP_AND_PAPER_FILES: '/reports/pulp_and_paper/files',
  REPORTS_PULP_AND_PAPER_LAUNCHPAD: '/reports/pulp_and_paper/launchpad',
  REPORTS_QUANT_STRATEGY: REPORT_URLS['quant-strategy'],
  REPORTS_REGIA_CREDIT_ALLOCATION_ONSHORE:
    REPORT_URLS['regia-credit-allocation-onshore'],
  REPORTS_REGIA_CREDIT_PORTFOLIO: REPORT_URLS['regia-credit-portfolio'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_BELTERRA:
    REPORT_URLS['regia-credit-portfolio-fidc-belterra'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_BELTERRA_PAINEL:
    REPORT_URLS['regia-credit-portfolio-fidc-belterra-painel'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_EXPENSES:
    REPORT_URLS['regia-credit-portfolio-fidc-expenses'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA:
    REPORT_URLS['regia-credit-portfolio-fidc-solagora'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA_II:
    REPORT_URLS['regia-credit-portfolio-fidc-solagora-ii'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA_III:
    REPORT_URLS['regia-credit-portfolio-fidc-solagora-iii'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA_PAINEL:
    REPORT_URLS['regia-credit-portfolio-fidc-solagora-painel'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL_III:
    REPORT_URLS['regia-credit-portfolio-fidc-solfacil-iii'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL_VI:
    REPORT_URLS['regia-credit-portfolio-fidc-solfacil-vi'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL_PAINEL:
    REPORT_URLS['regia-credit-portfolio-fidc-solfacil-painel'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_KOMPASS:
    REPORT_URLS['regia-credit-portfolio-fidc-kompass'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_KOMPASS_PAINEL:
    REPORT_URLS['regia-credit-portfolio-fidc-kompass-painel'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_DESENVOLVE_SP:
    REPORT_URLS['regia-credit-portfolio-fidc-desenvolve-sp'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_PETROBRAS:
    REPORT_URLS['regia-credit-portfolio-fidc-petrobras'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_PETROBRAS_PAINEL:
    REPORT_URLS['regia-credit-portfolio-fidc-petrobras-painel'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC:
    REPORT_URLS['regia-credit-portfolio-fidc'],
  REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL:
    REPORT_URLS['regia-credit-portfolio-fidc-solfacil'],
  REPORTS_REGIA_CREDIT_CADASTRO: REPORT_URLS['regia-credit-cadastro'],
  REPORTS_REGIA_CREDIT_ESG_INDEX_LAB: REPORT_URLS['regia-credit-esg-index-lab'],
  REPORTS_CREDIT_LIQUID_PORTFOLIO_IMPACT:
    REPORT_URLS['credit-liquid-portfolio-impact'],
  REPORTS_CREDIT_LIQUID_PORTFOLIO_INTRADAY:
    REPORT_URLS['credit-liquid-portfolio-intraday'],
  REPORTS_CREDIT_LIQUID_ROTINAS_AREA: REPORT_URLS['credit-liquid-rotinas-area'],
  REPORTS_CREDIT_LIQUID_ARQUIVOS: REPORT_URLS['credit-liquid-arquivos'],
  REPORTS_CREDIT_LIQUID_PIPELINE: REPORT_URLS['credit-liquid-pipeline'],
  REPORTS_CREDIT_LIQUID_SENTIMENT: REPORT_URLS['credit-liquid-sentiment'],
  REPORTS_CREDIT_LIQUID_APORTES_RESGATES:
    REPORT_URLS['credit-liquid-aportes-resgates'],
  REPORTS_REGIA_CREDIT_SRE: REPORT_URLS['regia-credit-sre'],
  REPORTS_RETAIL: REPORT_URLS['retail'],
  REPORTS_SAAS: '/reports/saas',
  REPORTS_SEMICON: '/reports/semicon',
  REPORTS_SEMICON_LAUNCHPAD: '/reports/semicon/launchpad',
  REPORTS_SEMICON_DECK: '/reports/semicon/deck',
  REPORTS_SEMICON_VALUATION: '/reports/semicon/valuation',
  REPORTS_SEMICON_WIKI: '/reports/semicon/wiki',
  REPORTS_SOCIAL_MEDIA: '/reports/social_media',
  REPORTS_SUGAR: '/reports/sugar',
  REPORTS_SUGAR_ANALYSIS: REPORT_URLS['sugar'],
  REPORTS_SUGAR_FILES: '/reports/sugar/files',
  REPORTS_SURPRISE: REPORT_URLS['surprise'],
  REPORTS_TELECOM: REPORT_URLS['telecom'],
  REPORTS_TEST: REPORT_URLS['test'],
  REPORTS_TRADING: REPORT_URLS['trading'],
  REPORTS_TRADING_BROKERAGE: REPORT_URLS['trading-brokerage'],
  REPORTS_TRADING_BUYBACK: REPORT_URLS['trading-buyback'],
  REPORTS_TRADING_DATAWISE: REPORT_URLS['trading-datawise'],
  REPORTS_TRADING_ORDER_MANAGEMENT_SYSTEM:
    REPORT_URLS['trading-order-management-system'],
  REPORTS_TRADING_PLAN_FIA_SOPHIS: REPORT_URLS['trading-plan-fia-sophis'],
  REPORTS_TRANSCRIPTS: REPORT_URLS['transcripts'],
  REPORTS_UPSIDE: REPORT_URLS['upside'],
  REPORTS_MACRO_BRAZIL_ACTIVITY_ANFAVEA: REPORT_URLS['brazil-activity-anfavea'],
  REPORTS_MACRO_BRAZIL_ACTIVITY_FORECASTS:
    REPORT_URLS['brazil-activity-forecasts'],
  REPORTS_MACRO_BRAZIL_ACTIVITY_GDP: REPORT_URLS['brazil-activity-gdp'],
  REPORTS_MACRO_BRAZIL_ACTIVITY_PIM: REPORT_URLS['brazil-activity-pim'],
  REPORTS_MACRO_BRAZIL_ACTIVITY_PMC: REPORT_URLS['brazil-activity-pmc'],
  REPORTS_MACRO_BRAZIL_ACTIVITY_PMS: REPORT_URLS['brazil-activity-pms'],
  REPORTS_MACRO_BRAZIL_BOP: REPORT_URLS['brazil-bop'],
  REPORTS_MACRO_BRAZIL_ICF_BCB: REPORT_URLS['brazil-icf-bcb'],
  REPORTS_MACRO_BRAZIL_CREDIT: REPORT_URLS['brazil-credit'],
  REPORTS_MACRO_BRAZIL_ENERGY_CCEE: REPORT_URLS['brazil-energy-ccee'],
  REPORTS_MACRO_BRAZIL_FISCAL: REPORT_URLS['brazil-fiscal'],
  REPORTS_MACRO_BRAZIL_FOCUS_EXPECTATIONS:
    REPORT_URLS['brazil-focus-expectations'],
  REPORTS_MACRO_BRAZIL_JGP_EXPECTATIONS: REPORT_URLS['brazil-jgp-expectations'],
  REPORTS_MACRO_BRAZIL_LABOUR_MARKET: REPORT_URLS['brazil-labour-market'],
  REPORTS_MACRO_BRAZIL_PRE_COPOM: REPORT_URLS['brazil-pre-copom'],
  REPORTS_MACRO_BRAZIL_PRICES_FGV: REPORT_URLS['brazil-prices-fgv'],
  REPORTS_MACRO_BRAZIL_PRICES_FIPE: REPORT_URLS['brazil-prices-fipe'],
  REPORTS_MACRO_BRAZIL_PRICES_INFLATION_MONITOR:
    REPORT_URLS['brazil-prices-inflation-monitor'],
  REPORTS_MACRO_BRAZIL_PRICES_IPCA: REPORT_URLS['brazil-prices-ipca'],
  REPORTS_MACRO_BRAZIL_PRICES_IPCA_15: REPORT_URLS['brazil-prices-ipca-15'],
  REPORTS_MACRO_BRAZIL_PRICES_IPCA_ENCADEADOS:
    REPORT_URLS['brazil-prices-ipca-encadeado'],
  REPORTS_MACRO_BRAZIL_PRICES_IPCA_MODELS:
    REPORT_URLS['brazil-prices-ipca-models'],
  REPORTS_MACRO_BRAZIL_REALTIME_ICBR: REPORT_URLS['brazil-realtime-icbr'],
  REPORTS_MACRO_BRAZIL_SURVEYS_FGV: REPORT_URLS['brazil-surveys-fgv'],
  REPORTS_MACRO_CHINA_ACTIVITY_PROXY: REPORT_URLS['china-activity-proxy'],
  REPORTS_MACRO_COUNTRY_AUSTRALIA: REPORT_URLS['country-australia'],
  REPORTS_MACRO_COUNTRY_CANADA: REPORT_URLS['country-canada'],
  REPORTS_MACRO_COUNTRY_CHILE: REPORT_URLS['country-chile'],
  REPORTS_MACRO_COUNTRY_CHINA: REPORT_URLS['country-china'],
  REPORTS_MACRO_COUNTRY_COLOMBIA: REPORT_URLS['country-colombia'],
  REPORTS_MACRO_COUNTRY_EURO_AREA: REPORT_URLS['country-euro-area'],
  REPORTS_MACRO_COUNTRY_GERMANY: REPORT_URLS['country-germany'],
  REPORTS_MACRO_COUNTRY_INDIA: REPORT_URLS['country-india'],
  REPORTS_MACRO_COUNTRY_JAPAN: REPORT_URLS['country-japan'],
  REPORTS_MACRO_COUNTRY_MEXICO: REPORT_URLS['country-mexico'],
  REPORTS_MACRO_COUNTRY_NEW_ZEALAND: REPORT_URLS['country-new-zealand'],
  REPORTS_MACRO_COUNTRY_NORWAY: REPORT_URLS['country-norway'],
  REPORTS_MACRO_COUNTRY_RUSSIA: REPORT_URLS['country-russia'],
  REPORTS_MACRO_COUNTRY_SOUTH_AFRICA: REPORT_URLS['country-south-africa'],
  REPORTS_MACRO_COUNTRY_SOUTH_KOREA: REPORT_URLS['country-south-korea'],
  REPORTS_MACRO_COUNTRY_SWEDEN: REPORT_URLS['country-sweden'],
  REPORTS_MACRO_COUNTRY_UNITED_KINGDOM: REPORT_URLS['country-united-kingdom'],
  REPORTS_MACRO_COUNTRY_UNITED_STATES: REPORT_URLS['country-united-states'],
  REPORTS_MACRO_EM_CHILE: REPORT_URLS['em-chile'],
  REPORTS_MACRO_EM_COLOMBIA: REPORT_URLS['em-colombia'],
  REPORTS_MACRO_EM_MEXICO: REPORT_URLS['em-mexico'],
  REPORTS_MACRO_EM_PM_MEETINGS: REPORT_URLS['em-monetary-policy-meetings'],
  REPORTS_MACRO_EM_SOUTH_AFRICA: REPORT_URLS['em-south-africa'],
  REPORTS_MACRO_FX_AND_RM_BEER: '/reports/macro/fx_and_rm_beer',
  REPORTS_MACRO_FX_AND_RM_BOND: '/reports/macro/fx_and_rm_bond',
  REPORTS_MACRO_FX_AND_RM_FLOWS_AND_POSITIONS:
    '/reports/macro/fx_and_rm_flows_and_positions',
  REPORTS_MACRO_GR_BIS_CREDIT: REPORT_URLS['gr-bis-credit'],
  REPORTS_MACRO_GR_CITI_SURPRISE: REPORT_URLS['gr-citi-economic-surprise'],
  REPORTS_MACRO_GR_CPI: REPORT_URLS['gr-cpi'],
  REPORTS_MACRO_GR_GDP_WEEKLY_TRACKER: REPORT_URLS['gr-gdp-weekly-tracker'],
  REPORTS_MACRO_GR_HLW_MODELS: REPORT_URLS['gr-hlw-models'],
  REPORTS_MACRO_GR_INDUSTRIALS_PRODUCTION:
    REPORT_URLS['gr-industrial-production'],
  REPORTS_MACRO_GR_LEADING_INDICATORS: REPORT_URLS['gr-leading-indicators'],
  REPORTS_MACRO_GR_MANUFACTURING_PRODUCTION:
    REPORT_URLS['gr-manufacturing-production'],
  REPORTS_MACRO_GR_NAIRU: REPORT_URLS['gr-nairu'],
  REPORTS_MACRO_GR_NOWCAST: REPORT_URLS['gr-nowcast'],
  REPORTS_MACRO_GR_PMI: REPORT_URLS['gr-pmi'],
  REPORTS_MACRO_GR_POLICY_RATE: REPORT_URLS['gr-policy-rate'],
  REPORTS_MACRO_GR_TAYLOR_RULE: REPORT_URLS['gr-taylor-rule'],
  REPORTS_MACRO_GR_TRADE_MONITOR: REPORT_URLS['gr-trade-monitor'],
  REPORTS_MACRO_HIGH_FREQUENCY_GOOGLE_TREND:
    REPORT_URLS['high-frequency-google-trends'],
  REPORTS_MACRO_HIGH_FREQUENCY_TRUFLATION:
    REPORT_URLS['high-frequency-truflation'],
  REPORTS_MACRO_US_CPI: REPORT_URLS['us-cpi'],
  REPORTS_MACRO_US_FOMC: REPORT_URLS['us-fomc'],
  REPORTS_MACRO_US_INFLATION_EXPECTATIONS:
    REPORT_URLS['us-inflation-expectations'],
  REPORTS_MACRO_US_PAYROLL: REPORT_URLS['us-payroll'],
  REPORTS_MACRO_US_PCE_INFLATION: REPORT_URLS['us-pce-inflation'],
  REPORTS_MACRO_US_PERSONAL_INCOME: REPORT_URLS['us-personal-income'],
  REPORTS_MACRO_US_RECESSION_PROBABILITY:
    REPORT_URLS['us-recession-probability'],
  REPORTS_MACRO_US_REGIONS_FED_SURVEYS: REPORT_URLS['us-regions-fed-surveys'],
  REPORTS_MACRO_US_RETAIL_SALES: REPORT_URLS['us-retail-sales'],
  REPORTS_PAIR_TRADING: REPORT_URLS['pair-trading'],
  REPORT_MANAGER: '/report_manager',
  REPORT_MANAGER_CONTROLS: '/report_manager/controls',
  REPORT_MANAGER_ELEMENTS: '/report_manager/elements',
  REPORT_MANAGER_REPORTS: '/report_manager/reports',
  REPORT_MANAGER_PRESENTATIONS: '/report_manager/presentations',
  REPORT_MANAGER_LAUNCHPADS: '/report_manager/launchpads',
  RESET_PASSWORD: '/resetpassword',
  RESET_PASSWORD_REQUEST: '/resetpassword/request',
  RESET_PASSWORD_FORM: '/resetpassword/form',
  SATELLITE: REPORT_URLS['satellite'],
  SCENARIO_ANALYSIS: REPORT_URLS['scenario-analysis'],
  SCREENING: '/reports/screening',
  SEARCH: '/search',
  SHARED_CHART: '/sharedchart',
  SHAREHOLDERS_MEETING: '/reports/shareholders_meeting',
  SHORT_SQUEEZE: '/reports/short_squeeze',
  SHORT_SQUEEZE_BZ_TRADING: '/reports/short_squeeze/bz_trading',
  SHORT_SQUEEZE_MACRO: REPORT_URLS['short-squeeze-macro'],
  SHORT_SQUEEZE_US_TRADING: '/reports/short_squeeze/us_trading',
  TECH_DISRUPTION: REPORT_URLS['tech-disruption'],
  TEST: '/test',
  TEST_CHART: '/test/chart',
  TEST_REPORT: '/test/report',
  UPDATE_SEARCH: '/update_search',
  USER: '/user',
  USER_DASHBOARD: '/user/dashboard',
  USER_NOTIFICATIONS: '/user/notifications',
  VALUATION: '/valuation',
  VALUATION_REPORT: REPORT_URLS['valuation-report'],
  VALUATION_SPX: REPORT_URLS['valuation-spx'],
  VESSELS: '/reports/vessels',
}

export const chartPalette = [
  '#16164D',
  '#297F0D',
  '#808080',
  '#e7b619',
  '#f57350',
  '#38387C',
  '#56CC2B',
  '#C0C0C0',
  '#FFD05A',
]

export const COMPASS_V1_PATH = 'https://compass.jgp.com.br'

const esgSubtree: SideBarTreeSection = {
  title: 'ESG',
  permissions: ['v2:compass:esg'],
  children: [
    {
      title: 'ESG Plataforma',
      path: 'https://esg-reports.jgp.com.br/reports',
    },
    {
      title: 'Gerenciamento de frameworks',
      path: Path.ESG_FRAMEWORK_MANAGER,
      permissions: ['v2:compass:esg:frameworks'],
    },
    {
      title: 'Dashboard',
      path: COMPASS_V1_PATH + '/credit/esgdashboard',
    },
    {
      title: 'Events',
      path: COMPASS_V1_PATH + '/esg/events',
    },
    {
      title: 'Emissões Certificadas',
      path: COMPASS_V1_PATH + '/esg/greenbonds',
    },
  ],
}

const equitySubtree: SideBarTreeSection = {
  title: 'Equity',
  permissions: ['v2:compass:equity'],
  children: [
    {
      title: 'Gestão',
      children: [
        {
          title: 'Launchpad',
          path: Path.LAUNCHPAD,
          permissions: ['v2:compass:equity:launchpad'],
        },
        {
          title: 'Portfolio',
          path: Path.PORTFOLIO,
          permissions: ['v2:compass:equity:portfolio'],
        },
        {
          title: 'Pair trading',
          path: Path.REPORTS_PAIR_TRADING,
          permissions: ['v2:compass:equity:pair_trading'],
        },
        {
          title: 'Portfolio analysis',
          path: Path.PORTFOLIO_ANALYSIS,
          permissions: ['v2:compass:equity:portfolio_analysis'],
        },
        {
          title: 'Performance attribution',
          path: Path.PERFORMANCE_ATTRIBUTION,
          permissions: ['v2:compass:equity:performance_attribution'],
        },
        {
          title: 'Dashboard',
          path: Path.REPORTS_DASHBOARD_TMP,
          permissions: ['v2:compass:equity:dashboard_report'],
        },
        {
          title: 'Dispersion Plot',
          path: Path.REPORTS_DISPERSION_PLOT,
          permissions: ['v2:compass:equity:dashboard_report'],
        },
        {
          // Sem `permissions`: a chave `analyst_notes` ainda nao existe em
          // @jgp-er-dev/permissions e o backend nao valida nada nessas rotas.
          // Herda o gate `v2:compass:equity` da secao. Trocar por
          // `permissions: ['v2:compass:equity:analyst_notes' as any]`
          // (precedente: credit_regia:cadastro, mais abaixo) quando o pacote
          // for bumpado.
          title: 'Analyst Notes',
          path: Path.ANALYST_NOTES,
        },
        {
          // No `permissions`: there is no momentum key in
          // @jgp-er-dev/permissions yet. Inherits the section's
          // `v2:compass:equity` gate, like Analyst Notes above.
          title: 'Momentum Screening',
          path: Path.MOMENTUM_SCREENING,
        },
      ],
    },
    {
      title: 'Strategy',
      children: [
        {
          title: 'AGO/E',
          path: Path.SHAREHOLDERS_MEETING,
          permissions: ['v2:compass:equity:shareholders_meeting'],
        },
        {
          title: 'Classification Analysis',
          path: Path.CLASSIFICATION_ANALYSIS,
          permissions: ['v2:compass:equity:classification_analysis'],
        },
        {
          title: 'Crypto',
          path: Path.REPORTS_CRYPTO,
          permissions: ['v2:compass:equity:crypto'],
        },
        {
          title: 'Cvm',
          permissions: ['v2:compass:equity:cvm'],
          children: [
            {
              title: 'Launchpad- Long bias',
              path: Path.CVM_LONG_BIAS_LAUNCHPAD,
            },
            {
              title: 'Launchpad- Long only',
              path: Path.CVM_LONG_ONLY_LAUNCHPAD,
            },
            {
              title: 'Analysis',
              path: Path.CVM_ANALYSIS,
            },
          ],
        },
        {
          title: 'Earnings',
          path: COMPASS_V1_PATH + '/equity/earnings',
        },
        {
          title: 'Earnings surprise',
          permissions: ['v2:compass:equity:global_scenario'],
          path: Path.REPORTS_EARNINGS_SURPRISE,
        },
        {
          title: 'ETF',
          permissions: ['v2:compass:equity:artificial_etfs'],
          children: [
            {
              title: 'Analysis',
              path: Path.ARTIFICIAL_ETFS_ANALYSIS,
            },
            {
              title: 'Launchpad',
              path: Path.ARTIFICIAL_ETFS_LAUNCHPAD,
            },
          ],
        },
        {
          title: 'Financial fraud',
          permissions: ['v2:compass:equity:financial_fraud'],
          path: Path.REPORTS_FINANCIAL_FRAUD,
        },
        {
          title: 'Financial Statement',
          permissions: ['v2:compass:equity:financial_statement'],
          children: [
            {
              title: 'Non-Financial',
              path: Path.REPORTS_FINANCIAL_STATEMENT_NON_FINANCIAL,
            },
            {
              title: 'IBOV',
              path: Path.REPORTS_FINANCIAL_STATEMENT_IBOV,
            },
            {
              title: 'Financials',
              path: Path.REPORTS_FINANCIAL_STATEMENT_FINANCIALS,
            },
          ],
        },
        {
          title: 'Flow',
          path: Path.REPORTS_FLOW,
          permissions: ['v2:compass:equity:flow'],
        },
        {
          title: 'Global scenario',
          path: Path.REPORTS_GLOBAL_SCENARIO,
          permissions: ['v2:compass:equity:global_scenario'],
        },
        {
          title: 'Insider Trading',
          path: Path.INSIDER_TRADING,
          permissions: ['v2:compass:equity:insider_trading'],
        },
        {
          title: 'Market structure',
          path: Path.MARKET_STRUCTURE,
          permissions: ['v2:compass:equity:market_structure'],
        },
        {
          title: 'Merge and acquisitions',
          permissions: ['v2:compass:equity:merge_and_acquisitions'],
          children: [
            {
              title: 'Analysis',
              path: Path.MERGE_AND_ACQUISITIONS_ANALYSIS,
            },
            {
              title: 'Files',
              path: Path.MERGE_AND_ACQUISITIONS_FILES,
            },
          ],
        },
        {
          title: 'Quant strategy',
          path: Path.REPORTS_QUANT_STRATEGY,
          permissions: ['v2:compass:equity:quant_strategy'],
        },
        {
          title: 'Scenario analysis',
          path: Path.SCENARIO_ANALYSIS,
          permissions: ['v2:compass:equity:commodities'],
        },
        {
          title: 'Screening',
          path: Path.SCREENING,
          permissions: ['v2:compass:equity:screening'],
        },
        {
          title: 'Short squeeze',
          permissions: ['v2:compass:equity:short_squeeze'],
          children: [
            {
              title: 'Trading - Us',
              path: Path.SHORT_SQUEEZE_US_TRADING,
            },
            {
              title: 'Trading - Bz',
              path: Path.SHORT_SQUEEZE_BZ_TRADING,
            },
            {
              title: 'Macro',
              path: Path.SHORT_SQUEEZE_MACRO,
            },
          ],
        },
        {
          title: 'Surprise',
          path: Path.REPORTS_SURPRISE,
          permissions: ['v2:compass:equity:surprise'],
        },
        {
          title: 'Positions',
          path: Path.REPORTS_POSITIONS,
          permissions: ['v2:compass:equity:options_report'],
        },
        {
          title: 'Tech disruption',
          path: Path.TECH_DISRUPTION,
          permissions: ['v2:compass:equity:tech_disruption'],
        },
        {
          title: 'Transcripts',
          path: Path.REPORTS_TRANSCRIPTS,
          permissions: ['v2:compass:equity:transcripts'],
        },
        {
          title: 'Upside',
          path: Path.REPORTS_UPSIDE,
          permissions: ['v2:compass:equity:upside'],
        },
        {
          title: 'Valuation',
          path: Path.VALUATION,
          permissions: ['v2:compass:equity:valuation'],
        },
        {
          title: 'Valuation Report',
          path: Path.VALUATION_REPORT,
          permissions: ['v2:compass:equity:valuation_report'],
        },
        {
          title: 'Valuation S&P',
          path: Path.VALUATION_SPX,
          permissions: ['v2:compass:equity:valuation_spx'],
        },
      ],
    },
    {
      title: 'Trading',
      children: [
        {
          title: 'Intraday Monitor',
          path: Path.INTRADAY_MONITOR,
          permissions: ['v2:compass:equity:trading'],
        },
        {
          title: 'Plan Fia Sophis',
          path: Path.REPORTS_TRADING_PLAN_FIA_SOPHIS,
          permissions: ['v2:compass:equity:trading'],
        },
        {
          title: 'Brokerage',
          path: Path.REPORTS_TRADING_BROKERAGE,
          permissions: ['v2:compass:equity:trading'],
        },
        {
          title: 'Order Management System',
          path: Path.REPORTS_TRADING_ORDER_MANAGEMENT_SYSTEM,
          permissions: ['v2:compass:equity:trading'],
        },
        {
          title: 'Buyback',
          path: Path.REPORTS_TRADING_BUYBACK,
          permissions: ['v2:compass:equity:trading'],
        },
        {
          title: 'Datawise',
          path: Path.REPORTS_TRADING_DATAWISE,
          permissions: ['v2:compass:equity:trading'],
        },
        {
          title: 'Presentation',
          children: [
            {
              title: 'Trading Report',
              path: Path.PRESENTATIONS_TRADING_TRADING_REPORT,
            },
            {
              title: 'Buyback',
              path: Path.PRESENTATIONS_TRADING_BUYBACK,
            },
          ],
        },
      ],
    },
    {
      title: 'Sector',
      children: [
        {
          title: 'Agro',
          permissions: ['v2:compass:equity:agro'],
          children: [
            {
              title: 'Analysis',
              path: Path.REPORTS_AGRO_ANALYSIS,
            },
            {
              title: 'Files',
              path: Path.REPORTS_AGRO_FILES,
            },
          ],
        },
        {
          title: 'Airlines',
          path: Path.REPORTS_AIRLINES,
          permissions: ['v2:compass:equity:airlines'],
        },
        {
          title: 'Apparel',
          path: Path.REPORTS_APPAREL,
          permissions: ['v2:compass:equity:apparel'],
        },
        {
          title: 'Banks',
          permissions: ['v2:compass:equity:banks'],
          children: [
            {
              title: 'Analysis',
              path: Path.REPORTS_BANKS_ANALYSIS,
            },
            {
              title: 'Files',
              path: Path.REPORTS_BANKS_FILES,
            },
          ],
        },
        {
          title: 'Capital markets',
          path: Path.REPORTS_CAPITAL_MARKETS,
          permissions: ['v2:compass:equity:capital_markets'],
        },
        {
          title: 'Car rental',
          path: Path.REPORTS_CAR_RENTAL,
          permissions: ['v2:compass:equity:car_rental'],
        },
        {
          title: 'China battery materials',
          path: Path.REPORTS_CHINA_BATTERY_MATERIALS,
          permissions: ['v2:compass:equity:china_battery_materials'],
        },
        {
          title: 'Commodities',
          path: Path.REPORTS_COMMODITIES,
          permissions: ['v2:compass:equity:commodities'],
        },
        {
          title: 'Consumer',
          path: Path.REPORTS_CONSUMER,
          permissions: ['v2:compass:equity:consumer'],
        },
        {
          title: 'Consumer monitor',
          path: Path.REPORTS_CONSUMER_MONITOR,
          permissions: ['v2:compass:equity:consumer_monitor'],
        },
        {
          title: 'Distribution',
          path: Path.REPORTS_DISTRIBUTION,
          permissions: ['v2:compass:equity:distribution'],
        },
        {
          title: 'Ecommerce',
          permissions: ['v2:compass:equity:ecommerce'],
          children: [
            {
              title: 'Amazon',
              path: Path.REPORTS_E_COMMERCE_AMAZON,
            },
            {
              title: 'Enjoei',
              path: Path.REPORTS_E_COMMERCE_ENJOEI,
            },
            {
              title: 'Meli',
              path: Path.REPORTS_E_COMMERCE_MELI,
            },
            {
              title: 'Sellers Meli',
              path: Path.REPORTS_E_COMMERCE_SELLERS_MELI,
            },
            {
              title: "Rothy's",
              path: Path.REPORTS_E_COMMERCE_ROTHYS,
            },
            {
              title: 'Westwing',
              path: Path.REPORTS_E_COMMERCE_WESTWING,
            },
            {
              title: 'Launchpad',
              path: Path.REPORTS_E_COMMERCE_LAUNCHPAD,
            },
            {
              title: 'Valuation',
              path: Path.REPORTS_E_COMMERCE_VALUATION,
            },
          ],
        },
        {
          title: 'Education',
          permissions: ['v2:compass:equity:education'],
          children: [
            {
              title: 'Superior',
              path: Path.REPORTS_EDUCATION_SUPERIOR,
            },
            {
              title: 'Valuation',
              path: Path.REPORTS_EDUCATION_VALUATION,
            },
          ],
        },
        {
          title: 'Energy Shortage',
          path: Path.REPORTS_ENERGY_SHORTAGE,
          permissions: ['v2:compass:equity:energy_shortage'],
        },
        {
          title: 'Exchange',
          path: Path.REPORTS_EXCHANGE,
          permissions: ['v2:compass:equity:exchange'],
        },
        {
          title: 'Healthcare',
          permissions: ['v2:compass:equity:healthcare'],
          children: [
            {
              title: 'Dados por operadoras',
              path: Path.REPORTS_HEALTHCARE_OPERADORAS,
            },
            {
              title: 'Membros por região',
              path: Path.REPORTS_HEALTHCARE_MEMBROS,
            },
            {
              title: 'Operadoras por região',
              path: Path.REPORTS_HEALTHCARE_OPERATORS_BY_REGION,
            },
            {
              title: 'Update mensal',
              path: Path.REPORTS_HEALTHCARE_UPDATE_MENSAL,
            },
            {
              title: 'Valuation',
              path: Path.REPORTS_HEALTHCARE_VALUATION,
            },
          ],
        },
        {
          title: 'Homebuilders',
          path: Path.REPORTS_HOMEBUILDERS,
          permissions: ['v2:compass:equity:homebuilders'],
        },
        {
          title: 'Industrials',
          path: Path.REPORTS_INDUSTRIALS,
          permissions: ['v2:compass:equity:industrials'],
        },
        {
          title: 'Insurance',
          path: Path.REPORTS_INSURANCE,
          permissions: ['v2:compass:equity:insurance'],
        },
        {
          title: 'Lithium',
          path: Path.REPORTS_LITHIUM,
          permissions: ['v2:compass:equity:lithium'],
        },
        {
          title: 'Macro Analysis',
          path: Path.REPORTS_MACRO_ANALYSIS,
          permissions: ['v2:compass:equity:macro_analysis'],
        },
        {
          title: 'Macro report',
          path: Path.MACRO_REPORT,
          permissions: ['v2:compass:equity:macro_report'],
        },
        {
          title: 'Metals and mining',
          permissions: ['v2:compass:equity:metals_and_mining'],
          children: [
            {
              title: 'Analysis',
              path: Path.REPORTS_METALS_AND_MINING_ANALYSIS,
            },
            {
              title: 'Launchpad',
              path: Path.REPORTS_METALS_AND_MINING_LAUNCHPAD,
            },
            {
              title: 'Files',
              path: Path.REPORTS_METALS_AND_MINING_FILES,
            },
          ],
        },
        {
          title: 'Oil',
          permissions: ['v2:compass:equity:oil'],
          children: [
            {
              title: 'Analysis',
              path: Path.REPORTS_OIL_ANALYSIS,
            },
            {
              title: 'Files',
              path: Path.REPORTS_OIL_FILES,
            },
          ],
        },
        {
          title: 'Payments',
          path: Path.REPORTS_PAYMENTS,
          permissions: ['v2:compass:equity:payments'],
        },
        {
          title: 'Proteins',
          permissions: ['v2:compass:equity:proteins'],
          children: [
            {
              title: 'AUS Beef',
              path: Path.REPORTS_PROTEINS_AUS_BEEF,
            },
            {
              title: 'Analysis',
              path: Path.REPORTS_PROTEINS_ANALYSIS,
            },
            {
              title: 'BZ Beef',
              path: Path.REPORTS_PROTEINS_BZ_BEEF,
            },
            {
              title: 'BZ Chicken',
              path: Path.REPORTS_PROTEINS_BZ_CHICKEN,
            },
            {
              title: 'Files',
              path: Path.REPORTS_PROTEINS_FILES,
            },
            {
              title: 'Global Markets',
              path: Path.REPORTS_PROTEINS_GLOBAL_MARKETS,
            },
            {
              title: 'US Beef',
              path: Path.REPORTS_PROTEINS_US_BEEF,
            },
            {
              title: 'US Chicken',
              path: Path.REPORTS_PROTEINS_US_CHICKEN,
            },
            {
              title: 'US Pork',
              path: Path.REPORTS_PROTEINS_US_PORK,
            },
            {
              title: 'Valuation',
              path: Path.REPORTS_PROTEINS_VALUATION,
            },
          ],
        },
        {
          title: 'Pulp and paper',
          permissions: ['v2:compass:equity:pulp_and_paper'],
          children: [
            {
              title: 'Analysis',
              path: Path.REPORTS_PULP_AND_PAPER_ANALYSIS,
            },
            {
              title: 'Launchpad',
              path: Path.REPORTS_PULP_AND_PAPER_LAUNCHPAD,
            },
            {
              title: 'Files',
              path: Path.REPORTS_PULP_AND_PAPER_FILES,
            },
          ],
        },
        {
          title: 'Retail',
          path: Path.REPORTS_RETAIL,
          permissions: ['v2:compass:equity:retail'],
        },
        {
          title: 'Saas',
          path: Path.REPORTS_SAAS,
          permissions: ['v2:compass:equity:saas'],
        },
        {
          title: 'Sugar',
          permissions: ['v2:compass:equity:sugar'],
          children: [
            {
              title: 'Analysis',
              path: Path.REPORTS_SUGAR_ANALYSIS,
            },
            {
              title: 'Files',
              path: Path.REPORTS_SUGAR_FILES,
            },
          ],
        },
        {
          title: 'Telecom',
          path: Path.REPORTS_TELECOM,
          permissions: ['v2:compass:equity:telecom'],
        },
        {
          title: 'Utilities',
          path: Path.REPORTS_UTILITIES,
          permissions: ['v2:compass:equity:utilities'],
        },
      ],
    },
    {
      title: 'Semicon',
      permissions: ['v2:compass:equity:launchpad'],
      children: [
        {
          title: 'Launchpad',
          path: Path.REPORTS_SEMICON_LAUNCHPAD,
        },
        {
          title: 'Semicon - Valuation',
          path: Path.REPORTS_SEMICON_VALUATION,
          permissions: ['v2:compass:equity:launchpad'],
        },
        {
          // Acesso restrito a uma lista nominal (papel v2:semicon), nao ao gate
          // da secao, que todo usuario JGP tem.
          title: 'Research Wiki',
          path: Path.REPORTS_SEMICON_WIKI,
          permissions: ['v2:compass:semicon:wiki'],
        },
        // Deck buttons are auto-listed at runtime from /decks/index.json
        // (see useSideBarTree in App.tsx). To add one, drop a folder in
        // R:\Compass\Semicon\sites — no code change needed.
      ],
    },
    {
      title: 'Alternative data',
      children: [
        {
          title: 'Congresso',
          path: Path.DEPUTIES_VOTES,
          permissions: ['v2:compass:equity:deputies_votes'],
        },
        {
          title: 'Covid',
          path: COMPASS_V1_PATH + '/equity/covid',
        },
        {
          title: 'Covid-19 Mobility Scenarios',
          path: COMPASS_V1_PATH + '/equity/scenarioscovid',
        },
        {
          title: 'Nlp Models',
          path: Path.REPORTS_NLP_MODELS,
          permissions: ['v2:compass:equity:nlp_models'],
        },
        {
          title: 'Satellite',
          path: Path.SATELLITE,
          permissions: ['v2:compass:equity:satellite'],
        },
        {
          title: 'Social Media',
          path: Path.REPORTS_SOCIAL_MEDIA,
          permissions: ['v2:compass:equity:social_media'],
        },
        {
          title: 'Vessels',
          path: Path.VESSELS,
          permissions: ['v2:compass:equity:vessels'],
        },
      ],
    },
    {
      title: 'Presentations',
      children: [
        {
          title: 'Banks',
          path: Path.PRESENTATIONS_BANKS,
        },
        {
          title: 'Coverage',
          children: [
            {
              title: 'Commodities',
              path: Path.PRESENTATIONS_COMMODITIES_COVERAGE,
            },
            {
              title: 'Luca Teixeira',
              path: Path.PRESENTATIONS_LTEIXEIRA_COVERAGE,
            },
            {
              title: 'Marina Greenman',
              path: Path.PRESENTATIONS_MGREENMAN_AND_DPONDE_COVERAGE,
            },
            {
              title: 'Pedro Romeiro',
              path: Path.PRESENTATIONS_PROMEIRO_COVERAGE,
            },
            { title: 'Urbano Lorea', path: Path.PRESENTATIONS_ULOREA_COVERAGE },
          ],
        },
        {
          title: 'Dividends',
          path: Path.PRESENTATIONS_DIVIDENDS,
        },
        {
          title: 'Hapvida',
          path: Path.PRESENTATIONS_HAPVIDA,
        },
        {
          title: 'Inadimplência',
          path: Path.PRESENTATIONS_BANKS_DEFAULT,
        },
        {
          title: 'Metals and mining',
          path: Path.PRESENTATIONS_METALS_AND_MINING,
        },
        {
          title: 'Multifactor models',
          path: Path.PRESENTATIONS_MULTIFACTOR_MODELS,
        },
        {
          title: 'Norms',
          path: Path.PRESENTATIONS_NORMS,
        },
        {
          title: 'Performance attribution',
          path: Path.PRESENTATIONS_PERFORMANCE_ATTRIBUTION,
        },
        {
          title: 'Portfolio insights',
          path: Path.PRESENTATIONS_PORTFOLIO_INSIGHTS,
        },
        {
          title: 'Sales',
          path: Path.PRESENTATIONS_SALES,
        },
        {
          title: 'S&P Valuation',
          path: Path.PRESENTATIONS_VALUATION_SPX,
        },
        {
          title: 'S&P papers',
          path: Path.PRESENTATIONS_SPX_PAPERS,
        },
        {
          title: 'Strategy',
          path: Path.PRESENTATIONS_STRATEGY,
        },
        {
          title: 'Trade ideas',
          path: Path.PRESENTATIONS_TRADING_IDEAS,
        },
        {
          title: 'Telecom',
          path: Path.PRESENTATIONS_TELECOM,
        },
        {
          title: 'Utilities',
          path: Path.PRESENTATIONS_UTILITIES,
        },
      ],
    },
    // {
    //   title: 'Regia',
    //   children: [
    //     {
    //       title: 'Gestão',
    //       children: [
    //         {
    //           title: 'Allocation',
    //           path: Path.REPORTS_REGIA_CREDIT_ALLOCATION_ONSHORE,
    //           permissions: [
    //             'v2:compass:equity:regia_credit_allocation_onshore',
    //           ],
    //         },
    //         {
    //           title: 'Portfolio FIDC',
    //           path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC,
    //           permissions: ['v2:compass:equity:regia_credit_portfolio_fidcs'],
    //         },
    //         {
    //           title: 'Portfolio FIDC - Solfácil',
    //           path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL,
    //           permissions: [
    //             'v2:compass:equity:regia_credit_portfolio_fidc_solfacil',
    //           ],
    //         },
    //         {
    //           title: 'Consolidated FIDCs',
    //           path: Path.REPORTS_CONSOLIDATED_FIDCS,
    //           permissions: ['v2:compass:equity:consolidated_fidcs'],
    //         },
    //         {
    //           title: 'Credit commodities',
    //           path: Path.REPORTS_CREDIT_COMMODITIES,
    //           permissions: ['v2:compass:equity:credit_commodities'],
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      title: 'Others',
      children: [
        {
          title: 'Dashboards',
          path: Path.REPORTS_HTML_DASHBOARDS,
          permissions: ['v2:compass:equity:html_dashboards'],
        },
        {
          title: 'Annotation',
          children: [
            {
              title: 'Annotation tool',
              path: Path.ANNOTATION,
            },
          ],
          permissions: ['v2:compass:equity:annotation'],
        },
        {
          title: 'Credit',
          path: Path.REPORTS_CREDIT,
          permissions: ['v2:compass:equity:credit'],
        },
        {
          title: 'Credit monitor',
          path: COMPASS_V1_PATH + '/credit/creditmonitor',
        },
        {
          title: 'Events',
          path: COMPASS_V1_PATH + '/equity/events',
        },
        {
          title: 'Launchpad monitor',
          path: Path.REPORTS_LAUNCHPAD_MONITOR,
          permissions: ['v2:compass:equity:launchpad_monitor'],
        },
        {
          title: 'Scheduler',
          path: COMPASS_V1_PATH + '/equity/processscheduler',
        },
        {
          title: 'Volatility Analysis',
          path: COMPASS_V1_PATH + '/risk/equityvolanalysis',
        },
        {
          title: 'Volatility Screening',
          path: COMPASS_V1_PATH + '/risk/screeningvol',
        },
      ],
    },
    {
      title: 'Configuration',
      children: [
        {
          title: 'Baskets manager',
          path: Path.BASKETS,
          permissions: ['v2:compass:equity:baskets'],
        },
        {
          title: 'Classification manager',
          path: Path.CLASSIFICATION_MANAGER,
          permissions: ['v2:compass:equity:classification_manager'],
        },
        {
          title: 'Notifications Manager',
          path: Path.NOTIFICATIONS_MANAGER,
          permissions: ['v2:compass:notifications:manager'],
        },
        {
          title: 'User Dashboard',
          path: Path.USER_DASHBOARD,
        },
        {
          title: 'User Notification',
          path: Path.USER_NOTIFICATIONS,
        },
      ],
    },
  ],
}

const realEstateSubtree: SideBarTreeSection = {
  title: 'Real Estate',
  permissions: ['v2:compass:real_estate'],
  children: [
    {
      title: 'Launchpad',
      path: Path.LAUNCHPAD_REAL_ESTATE,
      permissions: ['v2:compass:real_estate:launchpad'],
    },
    {
      title: 'Portfolio',
      path: Path.PORTFOLIO_REAL_ESTATE,
      permissions: ['v2:compass:equity:portfolio'],
    },
  ],
}

// "SRE" saiu daqui em 28/09/2026 (a pedido), junto com "Controle Hedge" em
// Crédito Líquido > Gestão. Nos dois casos foi só o ITEM DE MENU: a rota
// /reports/regia_credit_sre segue servindo a página (ver reports/pages) e
// /controle-hedge segue redirecionando para a aba Hedge da Análise da Carteira.
// Quem tem o link salvo continua chegando; o menu é que deixou de oferecer.
//
// "Commodities" desceu no mesmo dia da raiz de Credit Regia para dentro de
// Crédito Ilíquido, ao lado do Swap Manager: os dois são FERRAMENTA, e o bloco
// "Portfolio FIDC - ..." acima deles é portfólio. A permissão do item não mudou
// (`credit_regia:commodities`) — ela é do relatório, não do lugar no menu.
const creditRegiaSubtree: SideBarTreeSection = {
  title: 'Credit Regia',
  permissions: ['v2:compass:credit_regia'],
  // Clicar aqui ENTRA na tela da seção, como em qualquer outra. A diferença
  // está lá dentro: os submenus abrem em ÁRVORE, no lugar, em vez de trocar a
  // lista a cada nível — dá para ver Gestão e Análise ao mesmo tempo e pular
  // entre páginas sem refazer o caminho. Os outros ramos de topo (ESG, Equity,
  // Real Estate) são de outras áreas e seguem entrando e voltando como sempre.
  expandir: true,
  children: [
    {
      title: 'Cadastro',
      icone: 'cadastro',
      path: Path.REPORTS_REGIA_CREDIT_CADASTRO,
      permissions: ['v2:compass:credit_regia:cadastro' as any],
    },
    {
      title: 'Crédito Líquido',
      icone: 'credito-liquido',
      permissions: ['v2:compass:equity:credit'],
      children: [
        {
          title: 'Gestão',
          permissions: ['v2:compass:equity:credit'],
          children: [
            {
              title: 'Análise da Carteira',
              path: Path.REPORTS_CREDIT_LIQUID_PORTFOLIO_IMPACT,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Portfolio Intraday',
              path: Path.REPORTS_CREDIT_LIQUID_PORTFOLIO_INTRADAY,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Calls e Trades',
              path: Path.CALLS_TRADES,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Peers de Mercado',
              path: Path.PEERS_MERCADO,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Rotinas da Área',
              path: Path.REPORTS_CREDIT_LIQUID_ROTINAS_AREA,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Arquivos',
              path: Path.REPORTS_CREDIT_LIQUID_ARQUIVOS,
              permissions: ['v2:compass:equity:credit'],
            },
          ],
        },
        {
          title: 'Análise',
          permissions: ['v2:compass:equity:credit'],
          children: [
            {
              title: 'Curva Empresas',
              path: Path.CURVA_EMPRESAS_V2,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Research',
              path: Path.PIPELINE_ANALISE_CREDITO,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Dados de Mercado',
              path: Path.DADOS_DE_MERCADO,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Captação Indústria',
              path: Path.REPORTS_CREDIT_LIQUID_APORTES_RESGATES,
              permissions: ['v2:compass:equity:credit'],
            },
            {
              title: 'Detentores (HDS)',
              path: Path.HDS,
              permissions: ['v2:compass:equity:credit'],
            },
          ],
        },
      ],
    },
    {
      title: 'Crédito Ilíquido',
      icone: 'credito-iliquido',
      permissions: ['v2:compass:credit_regia'],
      children: [
        // The painéis first, ahead of the older per-fund report pages.
        {
          // One page for the three funds; the page itself shows only the funds
          // the user may see (each fund page's own permission).
          title: 'Painel FIDC - Sol Agora',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA_PAINEL,
          permissions: ['v2:compass:credit_regia'],
        },
        {
          // One page for Sol Fácil III and VI; the page itself shows only the
          // funds the user may see (each fund report's permission).
          title: 'Painel FIDC - Sol Fácil',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL_PAINEL,
          permissions: ['v2:compass:credit_regia'],
        },
        {
          // The page itself shows the painel only to who can open the
          // Belterra report (its permission); NotFound otherwise.
          title: 'Painel FIDC - Belterra',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_BELTERRA_PAINEL,
          permissions: ['v2:compass:credit_regia'],
        },
        {
          // The page itself shows the painel only to who can open the
          // Petrobras report (its permission); NotFound otherwise.
          title: 'Painel FIDC - Petrobras',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_PETROBRAS_PAINEL,
          permissions: ['v2:compass:credit_regia'],
        },
        {
          // The page itself shows the painel only to who can open the
          // Kompass report (its permission); NotFound otherwise.
          title: 'Painel FIDC - Kompass',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_KOMPASS_PAINEL,
          permissions: ['v2:compass:credit_regia'],
        },
        {
          title: 'Portfolio FIDC - Belterra',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_BELTERRA,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_belterra',
          ],
        },
        {
          title: 'Portfolio FIDC - Expenses',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_EXPENSES,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_expenses',
          ],
        },
        {
          title: 'Portfolio FIDC - Sol Agora',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_solagora',
          ],
        },
        {
          title: 'Portfolio FIDC - Sol Agora II',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA_II,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_solagora_ii',
          ],
        },
        {
          title: 'Portfolio FIDC - Sol Agora III',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLAGORA_III,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_solagora_iii',
          ],
        },
        {
          title: 'Portfolio FIDC - Sol Fácil III',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL_III,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_solfacil_iii',
          ],
        },
        {
          title: 'Portfolio FIDC - Sol Fácil VI',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_SOLFACIL_VI,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_solfacil_vi',
          ],
        },
        {
          title: 'Portfolio FIDC - Kompass',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_KOMPASS,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_kompass',
          ],
        },
        {
          title: 'Portfolio FIDC - Desenvolve SP',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_DESENVOLVE_SP,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_desenvolve_sp',
          ],
        },
        {
          title: 'Portfolio FIDC - Petrobras',
          path: Path.REPORTS_REGIA_CREDIT_PORTFOLIO_FIDC_PETROBRAS,
          permissions: [
            'v2:compass:credit_regia:regia_credit_portfolio_fidc_petrobras',
          ],
        },
        {
          title: 'Commodities',
          path: Path.REPORTS_CREDIT_COMMODITIES,
          permissions: ['v2:compass:credit_regia:commodities'],
        },
        {
          title: 'Swap Manager',
          path: Path.REPORTS_SWAP_MANAGER,
          permissions: ['v2:compass:equity:credit'],
        },
      ],
    },
    {
      // `as any` until @jgp-er-dev/permissions ships the name (as Cadastro).
      title: 'Índice ESG — Laboratório',
      icone: 'esg',
      path: Path.REPORTS_REGIA_CREDIT_ESG_INDEX_LAB,
      permissions: ['v2:compass:credit_regia:esg_index_lab'],
    },
  ],
}

export const sideBarTree: SideBarTreeSection = {
  title: 'Menu principal',
  children: [esgSubtree, equitySubtree, realEstateSubtree, creditRegiaSubtree],
}

export const DEFAULT_PAGE_TITLE = 'Compass v2'
